import { AdminLayout } from '@/components/layouts'
import { SurveyForm } from './SurveyForm'

interface Community {
  id: number
  name: string
}

interface Answer {
  text: string
}

interface Survey {
  id: number
  title: string
  question: string
  answers: Answer[]
  multiple_choice: boolean
  points_reward: number
  start_date: string
  end_date: string
  published: boolean
  community_id: number
}

interface EditProps {
  survey: Survey
  communities: Community[]
}

export default function Edit({ survey, communities }: EditProps) {
  return (
    <AdminLayout
      title="Modifier Sondage"
      breadcrumbs={[
        { label: 'Sondages', href: '/admin/surveys' },
        { label: survey.title, href: `/admin/surveys/${survey.id}` },
        { label: 'Modifier' }
      ]}
    >
      <div className="max-w-3xl">
        <SurveyForm
          survey={survey}
          communities={communities}
          onSubmit={`/admin/surveys/${survey.id}`}
          isEdit
        />
      </div>
    </AdminLayout>
  )
}
